export default "__VITE_ASSET__BEhjdHmZ__"